<div *ngIf="(comment == null || comment.length == 0) && isInspector" class="upload-container" (click)="viewComponentComment()" title="{{'Add Comment' | translate | async}}">
  <i class="material-icons upload-container__icon">
    message
  </i>
</div>

<div *ngIf="comment != null && comment.length > 0" class="upload-container" (click)="viewComponentComment()" title="{{'Edit/View Comment' | translate | async}}">
  <i class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" >
    message
  </i>
</div>
<!-- <span class="comment" title="{{comment}}" *ngIf="comment != null && comment.length > 0" (click)="viewComponentComment()">{{comment | slice:0:20}}{{comment.length > 20 ? '...' : ''}}</span> -->
